<script>
import Chart from 'chart.js';

export default {
  name: 'AdminAccountsChart',
  props: {
    colors: Array,
    data: Object,
    loading: Boolean
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      if (this.data) {
        const data = {
          labels: ['Agency', 'Business', 'Personal'],
          datasets: [
            {
              data: [this.data.agency, this.data.business, this.data.personal],
              backgroundColor: this.colors,
              borderColor: 'white',
              borderWidth: 2
            }
          ]
        };

        return data;
      }
    }
  },
  watch: {
    data() {
      this.updateChart();
    }
  },
  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        animation: false,
        interiorText: 0,
        maintainAspectRatio: false,
        title: {
          display: false
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.labels[tooltipItem.index];
              const value = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toLocaleString();
              return `${label} (${value})`;
            }
          }
        }
      }
    });
    this.updateChart();
  },
  methods: {
    // Updates and renders the chart
    updateChart() {
      if (this.chartData) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  }
};
</script>

<template>
  <div class="account-chart-container">
    <h2 class="account-title">
      {{ data ? $n(data.total, 'integer') : 0 }}
      <small class="account-subtitle">Accounts</small>
    </h2>

    <div v-loading="loading" class="account-chart">
      <canvas ref="chart" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.account-title {
  font-size: 2rem;
  text-align: center;
}

.account-subtitle {
  display: block;
  font-size: $--font-size-small;
  color: $--color-gray-40;
}

.account-chart {
  position: relative;
  height: 12rem;
  margin-bottom: 2rem;

  @include breakpoint('sm-and-down') {
    height: 8rem;
  }
}
</style>
